<template>
  <div class="full-body">
    <div class="breadcrumb_section bg_gray page-title-mini">
      <div class="container">
        <!-- STRART CONTAINER -->
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="page-title">
              <h1>
                ACC {{ account.category.slug }} #{{ account.id }} -
                <span v-if="account.category.type === categoryTypes.MOBA">{{
                  account.rank.moba
                }}</span>
                <span v-else>{{ account.rank.fps }}</span>
              </h1>
              <h3>
                <span class="text-danger">
                  CARD : {{ Helper.formatMoney(account.price) }}<sup>đ</sup>
                </span>
                |
                <span class="text-success">
                  ATM : {{ Helper.formatMoney(account.atm_price) }}<sup>đ</sup>
                </span>
                <span>
                    <b-button class="btn btn-buy-now" @click="buyAcc">Mua Ngay</b-button>
                </span>
              </h3>

            </div>
          </div>
          <div class="col-md-6">
            <ol class="breadcrumb justify-content-md-end">
              <li class="breadcrumb-item">
                <a :href="route('home', website.domain)">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a
                  :href="
                    route('fe_viewcat', {
                      domain: website.domain,
                      cat: account.category.slug,
                    })
                  "
                  >{{ account.category.name }}</a
                >
              </li>
              <li class="breadcrumb-item active">
                {{ account.category.slug }} #{{ account.id }}
              </li>
            </ol>
          </div>
        </div>
      </div>
      <!-- END CONTAINER-->
    </div>
    <div class="main_content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="medium_divider clearfix"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div
              v-if="
                account.is_fake_sale === 'on' &&
                account.sale_sort === 1 &&
                !_.isEmpty(user)
              "
              class="tab-style3"
            >
              <h2>Hết hàng</h2>
            </div>
            <div v-else class="tab-style3">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="image"
                    data-toggle="tab"
                    href="#images"
                    role="tab"
                    aria-controls="Ảnh"
                    aria-selected="true"
                    >Ảnh</a
                  >
                </li>
                <li
                  class="nav-item"
                  v-if="
                    (account.category_id =
                      1 && !_.isEmpty(account.champion_list))
                  "
                >
                  <a
                    class="nav-link"
                    id="champion"
                    data-toggle="tab"
                    href="#champions"
                    role="tab"
                    aria-controls="champions"
                    aria-selected="false"
                    >Tướng ({{ account.champion_list.split("|").length }} )</a
                  >
                </li>
                <li
                  class="nav-item"
                  v-if="
                    (account.category_id = 1 && !_.isEmpty(account.skin_list))
                  "
                >
                  <a
                    class="nav-link"
                    id="skin"
                    data-toggle="tab"
                    href="#skins"
                    role="tab"
                    aria-controls="champions"
                    aria-selected="false"
                    >Skin ({{ account.skin_list.split("|").length }} )</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="desc"
                    data-toggle="tab"
                    href="#description"
                    role="tab"
                    aria-controls="description"
                    aria-selected="false"
                    >Thông tin thêm</a
                  >
                </li>
                <li class="ml-auto text-center">
                    <b-button class="btn btn-buy-now" @click="buyAcc">Mua Ngay</b-button>
                    <span v-if="account.price >= account.package.deposit_price_above">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="depositAcc(account)">
                        <!-- Đặt cọc {{ Helper.formatMoney(account.deposit_price) }}<sup>đ</sup>  -->
                        Trả góp
                      </button>
                    </span>
                </li>
              </ul>
              <div class="tab-content shop_info_tab">
                <div
                  class="tab-pane fade show active"
                  id="images"
                  role="tabpanel"
                  aria-labelledby="image"
                >
                  <div class="account-desc">
                    <div class="row">
                      <span class="col-4"
                            v-if="account.category.account_normal_configs.type && account.category.account_normal_configs.type.client_show">
                        <b>HÀNH TINH: <label>{{accountTypes[account.category.id][account.type]}}</label></b>
                      </span>
                      <span class="col-4"
                            v-if="account.category.account_normal_configs.server && account.category.account_normal_configs.server.client_show">
                        <b>SERVER: <label>{{accountServers[account.category.id][account.server]}}</label></b>
                      </span>
                    </div>
                    <div class="row"
                         v-if="account.category.id === accountCategories.NRO && packageShowVirtualRegistration.includes(account.account_package_id)">
                      <span class="col-12"><b>ĐĂNG KÝ: <label>ẢO</label></b></span>
                    </div>
                    <div class="row">
                      <span class="col-12">
                        <b>NỔI BẬT: <label v-html="account.content"></label></b>
                      </span>
                    </div>
                  </div>
                  <div v-for="image in images" :key="image" class="mt-1">
                    <img :src="image" alt="Image" width="100%" />
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="champions"
                  role="tabpanel"
                  aria-labelledby="champion"
                >
                  <div class="row" v-if="account.champion_list">
                    <div
                      v-for="champion in account.champion_list.split('|')"
                      :key="champion"
                      class="flex flex-col justify-content col-span-3 sm:col-span-2 md:col-span-1 border border-danger"
                      style="border-width: 2px; background-color: #0d0a0a"
                    >
                      <img
                        :src="getImageChampion(champion.split('_')[1])"
                        class="lazyload"
                        width="80px"
                        height="80px"
                      />
                      <div
                        class="h-8 flex items-center justify-center text-center bg-black text-yellow-500 w-full text-xs font-bold p-1 text-danger"
                        style="font-size: 12px; width: 80px"
                      >
                        <span class="block" style="overflow-wrap: break-word">{{
                          champion.split("_")[0]
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="skins"
                  role="tabpanel"
                  aria-labelledby="skin"
                >
                  <div class="row" v-if="account.skin_list">
                    <div
                      v-for="skin in account.skin_list.split('|')"
                      :key="skin"
                      class="col-span-4 md:col-span-1 border border-danger"
                      style="border-width: 2px; background-color: #0d0a0a"
                    >
                      <img
                        :src="getImageSkin(skin.split('_')[1])"
                        class="lazyload"
                        width="160px"
                        height="204px"
                      />
                      <div
                        class="h-12 flex items-center justify-center text-center bg-black text-yellow-500 w-full text-xs font-bold p-1 text-danger"
                        style="font-size: 12px; width: 160px"
                      >
                        <span class="block" style="overflow-wrap: break-word">{{
                          skin.split("_")[0]
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="description"
                  role="tabpanel"
                  aria-labelledby="desc"
                >
                  <div class="comments" v-html="account.content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="small_divider"></div>
            <div class="divider"></div>
            <div class="medium_divider"></div>
          </div>
        </div>
      </div>
    </div>
    <buy-account-modal-v3
      :user="user"
      :account="account"
      :website="website"
      :current-wallet="currentWallet"
      v-if="user"
    >
    </buy-account-modal-v3>

    <deposit-account-modal-v3
        :account="this.account"
        :user="this.user"
        :website="this.website"
        :current-wallet="currentWallet"
        :category-types="this.categoryTypes"
        @reload="handlePaginate(1)"
        v-if="user && account.price >= account.package.deposit_price_above"
    >
    </deposit-account-modal-v3>
  </div>
</template>

<script>
import BuyAccountModalV3 from "./BuyAccountModalV3.vue";
import DepositAccountModalV3 from "./DepositAccountModalV3.vue";

export default {
  components: { BuyAccountModalV3, DepositAccountModalV3 },
  props: {
    user: {
      Type: Object,
      data() {
        return {};
      },
    },
    currentWallet: {
      Type: Array,
      default() {
        return [];
      },
    },
    account: {
      Type: Object,
      data() {
        return {};
      },
    },
    categoryTypes: {
      Type: Object,
      default() {
        return {};
      },
    },
    accountTypes: {
      Type: Object,
      default() {
        return {};
      },
    },
    accountServers: {
      Type: Object,
      default() {
        return {};
      },
    },
    website: {
      Type: Object,
      data() {
        return {};
      },
    },
  },
  mounted() {
    if (this.account.images) {
        this.images = this.account.images.split(",");
    }
  },
  data() {
    return {
      accountCategories: {
        'NRO': 5,
      },
      packageShowVirtualRegistration: [10, 11],
      images: [],
    };
  },
  methods: {
    getImageChampion(imageId) {
      return `https://cdnshop.hxd.vn/champions/${imageId}.jpg`;
    },
    getImageSkin(imageId) {
      return `https://cdnshop.hxd.vn/skins/${imageId}.jpg`;
    },
    buyAcc() {
      if (!this.user) {
        window.location.href = "/login?domain=" + this.website.domain;
      }
      this.$bvModal.show("buyAccModal");
    },
    depositAcc() {
      if (!this.user){
        window.location.href = "/login?domain=" + this.website.domain;
      }
      this.$bvModal.show('depositAccModal');
    },
  },
};
</script>

<style scoped>
.account-desc span label {
    color: #FF324D;
}
.account-desc {
    padding-bottom: 30px;
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 40px;
}
::v-deep .account-desc p {
    color: #FF324D;
    line-height: unset;
    margin-bottom: 0;
}
</style>
